import React from "react";
import {useTranslation} from "react-i18next";
import MapRouteCalculatorManager from "./MapRouteCalculatorManager";

/**
 * FormRouteMap is a wrapper component that uses MapRouteCalculatorManager
 * to render either a Leaflet (OSRM) or Azure Maps based on the panel configuration.
 */
const FormRouteMap = ({center, geojson, waypoints, highlightedPoint, styleMap, duration, wasteType}) => {
    const {t: tF} = useTranslation("forms");
    return (
        <div style={styleMap}>
            <MapRouteCalculatorManager
                center={center}
                geojson={geojson}
                waypoints={waypoints}
                highlightedPoint={highlightedPoint}
                duration={duration}
                wasteType={wasteType}
                mapOnly={true}
                style={{height: "100%", width: "100%"}}
                // Pass optional setters as no-ops for read-only view
                setWaypoints={() => {}}
                setGeojson={() => {}}
                setDuration={() => {}}
                setHasChanged={() => {}}
                tF={tF}
            />
        </div>
    );
};

export default FormRouteMap;
